// Matches profile/Profile.js's real 3-card layout (avatar card, personal info, change password).
export default function ProfileSkeleton() {
    return (
        <div style={{ flex: 1, background: '#FAFAFA', padding: '32px 40px', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'center' }}>
            <div className="shine rounded-3" style={{ width: '100%', maxWidth: 780, height: 104, borderRadius: 13 }} />
            <div className="shine rounded-3" style={{ width: '100%', maxWidth: 780, height: 220, borderRadius: 13 }} />
            <div className="shine rounded-3" style={{ width: '100%', maxWidth: 780, height: 180, borderRadius: 13 }} />
        </div>
    );
}
